export const getTaskType = (path: string) => {
  if (path.includes('schedule_inspection')) {
    return 'SCHEDULE_INSPECTION';
  } else if (path.includes('inspection')) {
    return 'INSPECTION';
  } else if (path.includes('observation')) {
    return 'OBSERVATION';
  } else if (path.includes('incident')) {
    return 'INCIDENT';
  }

  return '';
};
